import React from "react";
import { Button, Modal } from "react-bootstrap";
import newLogo from "../../assets/new_logo.png";
import { useState } from "react";
import { useEffect } from "react";
import AxiosInstance from "../../AxiosInstance";
import { message } from "antd";

function VerifyPanModal(props) {
  const close = () => {
    props.setActive(false);
  };
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  useEffect(() => {
    if (props.active) {
      getUserPanData();
    }
  }, [props.pan, props.active]);
  const getUserPanData = async () => {
    const result = await AxiosInstance()
      .post("/common/verifyPan", {
        pan: props?.pan,
        idName: props.idName,
      })
      .catch((err) => {
        console.log();
        close();
        message.error(err.response.data.message);
        // alertError();
      });
    console.log(result);
    if (result.status === 200) {
      setLoading(false);
      setUserData(result.data.data);
    } else {
    }
  };
  const markPanVerified = async () => {
    const result = await AxiosInstance()
      .put("/profile/markPanAsVerified", {
        isPanVerified: true,
        idName: props.idName,
      })
      .catch((err) => {
        console.log();
        close();
        message.error(err.response.data.message);
        // alertError();
      });
    console.log(result);
    if (result.status === 200) {
      props.setPanVerified(true);
      message.success("Pan Verified Successfully");
      console.log();
      close();
    } else {
    }
  };
  return (
    <div>
      <Modal
        show={props.active}
        centered
        onHide={() => {
          props.setActive(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify PAN Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="d-flex justify-content-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div class="container">
              <div class="row">
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                  Name: {userData?.full_name}
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                  Pan Number: {userData?.pan_number}
                </div>
              </div>
            </div>

            // <div className="d-flex justify-content-center py-4">

            //   Please Verify Your Details.
            //   <div className="Col"> Name: {userData?.full_name}</div>
            //   <div className="Col"> Pan Number: {userData?.pan_number}</div>

            // </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="px-5 py-2 mx-1"
            variant="outline-primary"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
          <Button
            className="mx-1 px-4 py-2"
            onClick={() => {
              markPanVerified();
            }}
          >
            Yes, details are correct
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default VerifyPanModal;
